import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
    feedbackDuration: { type: Number, default: 1500 },
    successText: { type: String, default: "Copied!" }
  }

  static targets = ["source", "trigger"]

  copy(event) {
    event.preventDefault()

    const text = this.hasContentValue
      ? this.contentValue
      : this.hasSourceTarget
        ? this.sourceTarget.textContent.trim()
        : ""

    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback()
    }).catch(() => {
      this.fallbackCopy(text)
    })
  }

  showFeedback() {
    const trigger = this.hasTriggerTarget ? this.triggerTarget : this.element
    const originalText = trigger.textContent
    trigger.classList.add("copied")
    trigger.textContent = this.successTextValue

    setTimeout(() => {
      trigger.textContent = originalText
      trigger.classList.remove("copied")
    }, this.feedbackDurationValue)
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy")
      this.showFeedback()
    } catch {
      console.error("Clipboard: copy failed")
    } finally {
      document.body.removeChild(textarea)
    }
  }
}
